import React from "react";

const stats = [
    { value: "7rb+", label: "Member Aktif" },
    { value: "99.9%", label: "Uptime Server" },
    { value: "< 3 mnt", label: "Rata-rata Transaksi" },
    { value: "24/7", label: "Layanan CS" },
];

export default function Stats() {
    return (
        <section
            data-testid="stats-section"
            className="relative border-y border-white/10 bg-[#080808]"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
                    {stats.map((s, i) => (
                        <div
                            key={s.label}
                            data-testid={`stat-item-${i}`}
                            className="text-center md:text-left border-l-0 md:border-l md:first:border-l-0 md:pl-8 first:pl-0 border-white/10"
                        >
                            <div className="text-4xl md:text-6xl font-medium tracking-tighter text-gold-gradient">
                                {s.value}
                            </div>
                            <div className="mt-3 text-xs tracking-[0.2em] uppercase text-white/50">
                                {s.label}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
